/* AVS · Simulateurs d'abonnement (quantité selon le gabarit / économies avec l'abonnement)
   D'après les widgets d'Erwan (29/10/2026). Les données viennent de la fiche produit :
   métachamp custom.simulateur (posologie), custom.contenance, variantes (prix, poids), plans d'abonnement.
   Plusieurs instances par page possibles. Aucune variable globale hors window.AVSSim (garde anti double-chargement). */
(function () {
  if (window.AVSSim) return;
  window.AVSSim = true;

  var FREQ = [
    { id: '15j', d: 15, a: '15', b: 'jours', t: 'tous les 15 jours', plan: 'Tous les 15 jours' },
    { id: '1m', d: 30, a: '1', b: 'mois', t: 'tous les mois', plan: 'Tous les mois' },
    { id: '2m', d: 61, a: '2', b: 'mois', t: 'tous les 2 mois', plan: 'Tous les 2 mois' },
    { id: '3m', d: 91, a: '3', b: 'mois', t: 'tous les 3 mois', plan: 'Tous les 3 mois' },
    { id: '4m', d: 122, a: '4', b: 'mois', t: 'tous les 4 mois', plan: 'Tous les 4 mois' },
    { id: '5m', d: 152, a: '5', b: 'mois', t: 'tous les 5 mois', plan: 'Tous les 5 mois' },
    { id: '6m', d: 183, a: '6', b: 'mois', t: 'tous les 6 mois', plan: 'Tous les 6 mois' }
  ];
  var CAP = 14000, PACK = 500, CUIL = 1.5, FREE = 45; // colis max (g), carton (g), g par cuillère, livraison offerte (€)
  var QS = new URLSearchParams(location.search);
  var FRAC = { 0.25: '¼', 0.5: '½', 0.75: '¾' };
  var CAT_LABEL = { croquettes: 'Croquettes', patee: 'Pâtées', complement: 'Compléments', friandise: 'Friandises', soin: 'Soins' };

  function num(v) { return parseFloat(String(v == null ? '' : v).replace(',', '.')); }
  function eur(n) { return n.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
  function fr(n, d) { return n.toLocaleString('fr-FR', { maximumFractionDigits: d || 0 }); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function fire(el) { el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); }
  function freqById(id) { for (var i = 0; i < FREQ.length; i++) if (FREQ[i].id === id) return FREQ[i]; return null; }
  // Fréquences réellement proposées par le produit (d'après le nom des plans : « Tous les 2 mois avec -10% »)
  function freqsOf(p) {
    if (!p.plans || !p.plans.length) return FREQ.slice();
    return FREQ.filter(function (f) {
      return p.plans.some(function (n) { return n.indexOf(f.plan + ' ') === 0 || n === f.plan; });
    });
  }

  /* ---------- Pop-up ---------- */
  var openCount = 0;
  function shell(root, page, trigger, inner) {
    if (page) { root.innerHTML = '<div class="avs-card">' + inner + '</div>'; return null; }
    root.insertAdjacentHTML('beforeend', trigger + '<dialog aria-label="Simulateur"><div class="avs-card">' + inner + '</div></dialog>');
    var dlg = root.querySelector('dialog');
    dlg.openIt = function () {
      if (dlg.open) return;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      openCount++; document.documentElement.classList.add('avs-sim-open');
    };
    dlg.closeIt = function () { if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); } };
    dlg.addEventListener('close', function () {
      openCount = Math.max(0, openCount - 1);
      if (!openCount) document.documentElement.classList.remove('avs-sim-open');
    });
    root.querySelector('.avs-t').addEventListener('click', dlg.openIt);
    root.querySelector('.avs-x').addEventListener('click', dlg.closeIt);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.closeIt(); });
    return dlg;
  }

  /* ---------- Bloc d'achat de la fiche ---------- */
  function scopeOf(root) { return root.closest('.shopify-section') || document; }
  function mainForm(scope) {
    return scope.querySelector('.product-form form[action*="/cart/add"]') || scope.querySelector('form[action*="/cart/add"]');
  }
  function currentVariantId(root) {
    var f = mainForm(scopeOf(root)), i = f && f.querySelector('input[name="id"]');
    return i ? parseInt(i.value, 10) : null;
  }
  function waitFor(test, ms) {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function loop() { if (test() || Date.now() - t0 > ms) res(); else setTimeout(loop, 80); })();
    });
  }
  // Sélectionne la variante dans le sélecteur du thème (boutons ou liste), puis attend le rechargement des blocs abonnement / lots.
  function selectVariant(scope, v) {
    var form = mainForm(scope), idInput = form && form.querySelector('input[name="id"]');
    if (!v || (idInput && parseInt(idInput.value, 10) === v.id)) return Promise.resolve();
    var done = false;
    scope.querySelectorAll('variant-radios input[type="radio"], variant-selects input[type="radio"], fieldset input[type="radio"]').forEach(function (r) {
      if (!done && r.value === v.o && !r.closest('quantity-breaks')) { r.checked = true; fire(r); done = true; }
    });
    if (!done) scope.querySelectorAll('variant-selects select, variant-radios select').forEach(function (s) {
      for (var i = 0; !done && i < s.options.length; i++) if (s.options[i].value === v.o) { s.selectedIndex = i; fire(s); done = true; }
    });
    var sw = scope.querySelector('subscription-widget');
    return waitFor(function () {
      var ok = idInput && parseInt(idInput.value, 10) === v.id;
      return ok && !(sw && sw.classList.contains('subscription-widget--loading'));
    }, 4000).then(function () { return new Promise(function (r) { setTimeout(r, 150); }); });
  }
  function setQuantity(scope, qty) {
    var qb = scope.querySelector('quantity-breaks');
    var card = qb && qb.querySelector('.quantity-break[data-quantity="' + qty + '"]');
    if (card) { card.click(); return; }
    var form = mainForm(scope);
    var fields = [];
    if (form) form.querySelectorAll('input[name="quantity"]').forEach(function (i) { fields.push(i); });
    scope.querySelectorAll('.product-form__quantity input[name="quantity"], .js-qty-hidden, .js-qty-display').forEach(function (i) {
      if (fields.indexOf(i) < 0 && !i.closest('#stickyAddtocartContainer')) fields.push(i);
    });
    fields.forEach(function (i) { i.value = qty; fire(i); });
    document.dispatchEvent(new CustomEvent('form:quantity-update', { detail: { quantity: qty } }));
  }
  function setSubscription(scope, freqId) {
    var sw = scope.querySelector('subscription-widget');
    var f = freqById(freqId);
    if (!sw || !f) return null;
    var opt = sw.querySelector('.subscription-widget__option--subscription');
    var sel = opt && opt.querySelector('.deployer-select');
    var radio = opt && opt.querySelector('input[name="purchase_type"]');
    if (!sel || !radio) return null;
    for (var i = 0; i < sel.options.length; i++) {
      var txt = sel.options[i].text.trim();
      if (txt.indexOf(f.plan + ' ') === 0 || txt === f.plan) { sel.selectedIndex = i; break; }
    }
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return opt;
  }
  function toCart(root, variant, qty, freqId) {
    var scope = scopeOf(root);
    selectVariant(scope, variant).then(function () {
      if (qty) setQuantity(scope, qty);
      var target = freqId ? setSubscription(scope, freqId) : null;
      target = target || mainForm(scope);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Calcul quantité ---------- */
  function interp(xs, ys, w) {
    if (w <= xs[0]) return ys[0] * Math.pow(w / xs[0], 0.75);
    var n = xs.length - 1;
    if (w >= xs[n]) return ys[n] * Math.pow(w / xs[n], 0.75);
    for (var i = 1; i <= n; i++) if (w <= xs[i]) return ys[i - 1] + (ys[i] - ys[i - 1]) * (w - xs[i - 1]) / (xs[i] - xs[i - 1]);
  }
  function doseOf(f, w) {
    if (f.m === 'k') return f.k * w;
    if (f.m === 'i') return interp(f.xs, f.ys, w);
    var v = f.ys[0]; for (var i = 0; i < f.xs.length; i++) if (w >= f.xs[i]) v = f.ys[i]; return v;
  }
  function speciesOf(p) { return p.sim && p.sim.f ? Object.keys(p.sim.f) : []; }
  // Variante adaptée : règles sp/a/b du métachamp (pipettes), sinon la variante affichée.
  function variantFor(p, sp, w, curId) {
    var rules = (p.sim && p.sim.v) || {};
    var hit = null;
    p.vs.forEach(function (v) { var r = rules[v.t]; if (!hit && r && r.sp && r.sp === sp && w >= r.a && w <= r.b) hit = v; });
    if (hit) return hit;
    for (var i = 0; i < p.vs.length; i++) if (p.vs[i].id === curId) return p.vs[i];
    for (var j = 0; j < p.vs.length; j++) if (p.vs[j].id === p.cur) return p.vs[j];
    return p.vs[0];
  }
  function sizeOf(p, v, f) {
    var r = p.sim.v && p.sim.v[v.t];
    if (r && r.size) return r.size;
    if ((f.u === 'g' || f.u === 'ml') && p.ct > 0 && !(p.sim.v)) return p.ct;
    return p.sim.size;
  }
  function plan(p, v, size, daily) {
    var ok = [], other = [], g = v.g > 0 ? v.g : 0;
    freqsOf(p).forEach(function (f) {
      var units = Math.max(1, Math.ceil(daily * f.d / size - 0.05)), cov = units * size / daily;
      var o = { f: f, units: units, cov: cov, weight: units * g + PACK, r: cov / f.d };
      if (o.weight > CAP) return;
      (o.r >= 0.95 && o.r <= 1.3 ? ok : other).push(o);
    });
    if (ok.length) return ok.sort(function (a, b) { return Math.abs(a.f.d - 30) - Math.abs(b.f.d - 30) || b.f.d - a.f.d; })[0];
    if (other.length) return other.sort(function (a, b) { return a.r - b.r; })[0];
    return null;
  }
  function doseText(p, f, d) {
    if (f.u === 'pipette') return '<b>1 pipette</b> par mois';
    if (f.u === 'boîte') { var c = Math.round(d * 4) / 4, t = FRAC[c % 1] ? (Math.floor(c) ? Math.floor(c) + ' ' : '') + FRAC[c % 1] : fr(c, 2); return '<b>' + t + ' boîte' + (c > 1 ? 's' : '') + '</b> par jour'; }
    if (p.sim.cat === 'croquettes' || p.sim.cat === 'patee') return '<b>' + fr(d) + ' g</b> par jour';
    if (f.s) { var k = Math.round(d / CUIL * 100) / 100, tx = FRAC[k] || fr(k, 2); return '<b>' + tx + ' cuillère' + (k > 1 ? 's' : '') + ' doseuse' + (k > 1 ? 's' : '') + '</b> par jour' + (f.m === 'k' ? ' (' + fr(d, 1) + ' g)' : ''); }
    return '<b>' + fr(d, d < 1 ? 2 : 1) + ' ' + f.u + (f.u === 'comprimé' && d > 1 ? 's' : '') + '</b> par jour';
  }
  function range(sp) { return sp === 'Chat' ? { min: 1, max: 10, st: 0.5, def: 4 } : { min: 2, max: 70, st: 0.5, def: 15 }; }
  var ICON_Q = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v18"/><path d="M5 7h14"/><path d="M5 7l-3 7a3 3 0 0 0 6 0z"/><path d="M19 7l-3 7a3 3 0 0 0 6 0z"/><path d="M8 21h8"/></svg>';
  var ICON_E = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12"/><path d="M16 12h.01"/><path d="M4 8h14a2 2 0 0 1 2 2v2"/></svg>';

  function picker(list, cur, uid) {
    var groups = {};
    list.forEach(function (p) { var c = CAT_LABEL[p.sim && p.sim.cat] || 'Autres'; (groups[c] = groups[c] || []).push(p); });
    return '<div class="avs-f"><label class="avs-lbl" for="' + uid + '">Produit</label><select id="' + uid + '">' +
      Object.keys(groups).map(function (g) {
        return '<optgroup label="' + esc(g) + '">' + groups[g].map(function (p) {
          return '<option value="' + esc(p.h) + '"' + (p.h === cur.h ? ' selected' : '') + '>' + esc(p.n) + '</option>';
        }).join('') + '</optgroup>';
      }).join('') + '</select></div>';
  }
  var uidN = 0;

  function initQuantite(root, list, page) {
    list = list.filter(function (p) { return p.sim && p.sim.f && speciesOf(p).length; });
    if (!list.length) { root.hidden = true; return; }
    var u = 'avs-sim-' + (++uidN);
    var p = page ? (list.filter(function (x) { return x.h === QS.get('produit'); })[0] || list[0]) : list[0];
    var sps = speciesOf(p), qsp = (QS.get('espece') || '').toLowerCase();
    var sp = (qsp === 'chat' && sps.indexOf('Chat') >= 0) ? 'Chat' : (qsp === 'chien' && sps.indexOf('Chien') >= 0 ? 'Chien' : sps[0]);
    var rg = range(sp), w = num(QS.get('poids')); if (!(w > 0)) w = rg.def;
    var who = sps.length === 1 ? (sps[0] === 'Chat' ? 'votre chat' : 'votre chien') : 'votre animal';
    var inner = '<div class="avs-top"><div><p class="avs-eb">Selon son gabarit</p><p class="avs-ti">Combien lui en faut-il ?</p></div>' + (page ? '' : '<button type="button" class="avs-x" aria-label="Fermer">×</button>') + '</div>' +
      (page ? picker(list, p, u + '-p') : '<p class="avs-prod">' + esc(p.n) + '</p>') +
      '<div class="avs-f" data-spw><span class="avs-lbl">Pour</span><div class="avs-chips avs-sp" role="radiogroup" aria-label="Animal"><button type="button" class="avs-chip" role="radio" data-sp="Chien"><b>Chien</b></button><button type="button" class="avs-chip" role="radio" data-sp="Chat"><b>Chat</b></button></div></div>' +
      '<div class="avs-f"><label class="avs-lbl" for="' + u + '-r">Son poids</label><div class="avs-stp"><button type="button" data-m aria-label="Moins un kilo">−</button><output data-w aria-live="polite"></output><button type="button" data-pl aria-label="Plus un kilo">+</button></div><input type="range" id="' + u + '-r" data-r></div>' +
      '<div class="avs-res" aria-live="polite"><span class="avs-sub">Abonnement conseillé</span><span class="avs-big" data-big></span><span class="avs-sub" data-sub></span></div>' +
      '<ul class="avs-facts"><li data-l1></li><li data-l2></li><li data-l3></li></ul>' +
      (page ? '<a class="avs-cta" data-cta href="#">Voir le produit</a>' : '<button type="button" class="avs-cta" data-cta>Choisir cette quantité</button>') +
      '<p class="avs-note" data-note></p>';
    var dlg = shell(root, page, '<button type="button" class="avs-t">' + ICON_Q + '<span>On vous aide à trouver la fréquence parfaite pour ' + who + '</span></button>', inner);
    var $ = function (s) { return root.querySelector(s); }, r = $('[data-r]'), best = null, v = null;
    function setRange() { rg = range(sp); r.min = rg.min; r.max = rg.max; r.step = rg.st; w = Math.min(rg.max, Math.max(rg.min, w)); r.value = w; }
    function render() {
      sps = speciesOf(p); if (sps.indexOf(sp) < 0) { sp = sps[0]; setRange(); }
      var f = p.sim.f[sp];
      v = variantFor(p, sp, w, page ? null : currentVariantId(root));
      var size = sizeOf(p, v, f);
      $('[data-spw]').hidden = sps.length < 2;
      root.querySelectorAll('[data-sp]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.sp === sp); });
      var d = doseOf(f, w), daily = d * (f.j || 365) / 365; best = plan(p, v, size, daily);
      $('[data-w]').textContent = fr(w, 1) + ' kg';
      $('[data-m]').disabled = w <= rg.min; $('[data-pl]').disabled = w >= rg.max; r.value = w;
      var unit = function (n) { return n > 1 ? p.sim.u[1] : p.sim.u[0]; };
      if (best) {
        $('[data-big]').textContent = best.units + ' ' + unit(best.units) + ' ' + best.f.t;
        $('[data-sub]').textContent = 'couvre ' + fr(best.cov) + ' jours' + (v.g > 0 ? ' · colis de ' + fr(best.weight / 1000, 1) + ' kg' : '');
      } else {
        $('[data-big]').textContent = 'Plus de 14 kg par colis';
        $('[data-sub]').textContent = 'Contactez-nous pour un envoi en plusieurs colis.';
      }
      $('[data-l1]').innerHTML = '<span>' + doseText(p, f, d) + '</span>';
      var days = size / d;
      $('[data-l2]').hidden = f.u !== 'pipette' && days < 1.5;
      $('[data-l2]').textContent = f.u === 'pipette' ? '1 boîte de ' + size + ' pipettes dure ' + size + ' mois.' : '1 ' + p.sim.u[0] + ' dure environ ' + fr(days) + ' jours de prise.';
      $('[data-l3]').textContent = (f.j || 365) < 365 ? 'Pris en cure (' + f.j + ' jours par an) : quantité calculée sur l’année.' : 'Sans engagement : vous ajustez la quantité quand vous voulez.';
      $('[data-note]').textContent = (p.sim.v && p.sim.v[v.t] && p.sim.v[v.t].sp) ? 'Format choisi selon le poids : ' + v.t + '.' :
        (p.sim.cat === 'croquettes' || p.sim.cat === 'patee') ? 'Ration indicative pour une alimentation 100 % ' + (p.sim.cat === 'croquettes' ? 'croquettes' : 'pâtée') + ', à adapter à l’âge et à l’activité.' :
        'Posologie de la fiche produit. Demandez conseil à votre vétérinaire en cas de doute.';
      $('[data-cta]').hidden = !best;
      if (page) {
        $('[data-cta]').href = p.url + '?simulateur=quantite&poids=' + w + (sps.length > 1 ? '&espece=' + sp.toLowerCase() : '');
      } else if (best) {
        $('[data-cta]').textContent = 'Choisir ' + best.units + ' ' + unit(best.units) + ' ' + best.f.t;
      }
    }
    $('[data-m]').addEventListener('click', function () { w = Math.max(rg.min, Math.round((w - 1) * 2) / 2); render(); });
    $('[data-pl]').addEventListener('click', function () { w = Math.min(rg.max, Math.round((w + 1) * 2) / 2); render(); });
    r.addEventListener('input', function () { w = num(r.value); render(); });
    root.querySelectorAll('[data-sp]').forEach(function (b) {
      b.addEventListener('click', function () { if (sp === b.dataset.sp) return; sp = b.dataset.sp; w = range(sp).def; setRange(); render(); });
    });
    if (page) {
      $('#' + u + '-p').addEventListener('change', function (e) {
        p = list.filter(function (x) { return x.h === e.target.value; })[0];
        sps = speciesOf(p); if (sps.indexOf(sp) < 0) { sp = sps[0]; w = range(sp).def; }
        setRange(); render();
      });
    } else {
      $('[data-cta]').addEventListener('click', function () { dlg.closeIt(); if (best) toCart(root, v, best.units, best.f.id); });
      $('.avs-t').addEventListener('click', render); // recalcule si la variante a changé sur la fiche
    }
    setRange(); render();
    if (dlg && QS.get('simulateur') === 'quantite') dlg.openIt();
  }

  /* ---------- Économies ---------- */
  function initEconomies(root, list, page) {
    list = list.filter(function (p) { return p.plans && p.plans.length; });
    if (!list.length) { root.hidden = true; return; }
    var u = 'avs-sim-' + (++uidN);
    var p = page ? (list.filter(function (x) { return x.h === QS.get('produit'); })[0] || list[0]) : list[0];
    var qty = Math.max(1, parseInt(QS.get('qte'), 10) || 1), freq = null;
    function pickFreq(id) { var fs = freqsOf(p); freq = fs.filter(function (f) { return f.id === id; })[0] || (freq && fs.filter(function (f) { return f.id === freq.id; })[0]) || fs.filter(function (f) { return f.id === '1m'; })[0] || fs[0]; }
    pickFreq(QS.get('freq'));
    var pct = function () { return (p.pct || 10) / 100; };
    var inner = '<div class="avs-top"><div><p class="avs-eb" data-eb></p><p class="avs-ti">Combien vous économisez</p></div>' + (page ? '' : '<button type="button" class="avs-x" aria-label="Fermer">×</button>') + '</div>' +
      (page ? picker(list, p, u + '-p') : '<p class="avs-prod">' + esc(p.n) + '</p>') +
      '<div class="avs-res" aria-live="polite"><span class="avs-big" data-big></span><span class="avs-sub">économisés sur un an</span></div>' +
      '<div class="avs-f"><span class="avs-lbl">Quantité par envoi</span><div class="avs-stp"><button type="button" data-m aria-label="Moins">−</button><output data-q aria-live="polite"></output><button type="button" data-pl aria-label="Plus">+</button></div></div>' +
      '<div class="avs-f"><span class="avs-lbl">Une livraison</span><div class="avs-chips" role="radiogroup" aria-label="Fréquence" data-chips></div></div>' +
      '<ul class="avs-facts"><li data-l1></li><li data-l2></li><li>Sans engagement : vous modifiez ou annulez quand vous voulez.</li></ul>' +
      (page ? '<a class="avs-cta" data-cta href="#">Voir le produit</a>' : '<button type="button" class="avs-cta" data-cta>Choisir l’abonnement</button>');
    var dlg = shell(root, page, '<button type="button" class="avs-t">' + ICON_E + '<span>Combien j’économise en m’abonnant ?</span><small data-badge></small></button>', inner);
    var $ = function (s) { return root.querySelector(s); }, v = null;
    function chips() {
      $('[data-chips]').innerHTML = freqsOf(p).map(function (f) { return '<button type="button" class="avs-chip" role="radio" data-f="' + f.id + '"><b>' + f.a + '</b>' + f.b + '</button>'; }).join('');
      root.querySelectorAll('[data-f]').forEach(function (c) { c.addEventListener('click', function () { pickFreq(c.dataset.f); render(); }); });
    }
    function render() {
      v = variantFor(p, null, 0, page ? null : currentVariantId(root));
      var unit = p.sim && p.sim.u ? p.sim.u : ['unité', 'unités'];
      var per = v.p * qty, save = per * pct(), sub = per - save, n = 365 / freq.d;
      $('[data-eb]').textContent = 'Abonnement · −' + Math.round(pct() * 100) + ' %';
      if ($('[data-badge]')) $('[data-badge]').textContent = '−' + Math.round(pct() * 100) + ' %';
      $('[data-big]').textContent = eur(save * n);
      $('[data-q]').textContent = qty + ' ' + (qty > 1 ? unit[1] : unit[0]);
      $('[data-m]').disabled = qty <= 1;
      $('[data-l1]').innerHTML = '<span>' + eur(sub) + ' par envoi au lieu de <s>' + eur(per) + '</s>, ' + freq.t + '.</span>';
      $('[data-l2]').textContent = sub >= FREE ? 'Livraison offerte : chaque envoi dépasse ' + FREE + ' €.' : 'Encore ' + eur(FREE - sub) + ' par envoi pour la livraison offerte.';
      root.querySelectorAll('[data-f]').forEach(function (c) { c.setAttribute('aria-checked', c.dataset.f === freq.id); });
      if (page) $('[data-cta]').href = p.url + '?simulateur=economies&qte=' + qty + '&freq=' + freq.id;
    }
    $('[data-m]').addEventListener('click', function () { qty = Math.max(1, qty - 1); render(); });
    $('[data-pl]').addEventListener('click', function () { qty = Math.min(30, qty + 1); render(); });
    if (page) {
      $('#' + u + '-p').addEventListener('change', function (e) { p = list.filter(function (x) { return x.h === e.target.value; })[0]; qty = 1; pickFreq(freq.id); chips(); render(); });
    } else {
      $('[data-cta]').addEventListener('click', function () { dlg.closeIt(); toCart(root, null, qty, freq.id); });
      $('.avs-t').addEventListener('click', render);
    }
    chips(); render();
    if (dlg && QS.get('simulateur') === 'economies') dlg.openIt();
  }

  function boot() {
    document.querySelectorAll('.avs-sim[data-avs-sim]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var list = [];
      try { list = JSON.parse(root.querySelector('[data-avs-sim-data]').textContent) || []; } catch (e) { list = []; }
      var page = root.dataset.mode === 'page';
      if (root.dataset.avsSim === 'economies') initEconomies(root, list, page); else initQuantite(root, list, page);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
